import { createFileRoute, Link } from "@tanstack/react-router";
import { SEOHead } from "@/components/shared/SEOHead";
import { APP_STORE_URL } from "@/lib/utils";

export const Route = createFileRoute("/cart")({
  component: CartPage,
});

function CartPage() {
  return (
    <div className="page-enter bp-utility-page bp-business-page">
      <SEOHead
        title="Get the App — Quuil"
        description="Download the Quuil app to create, customize, and order custom products."
        path="/cart"
        robots="noindex,follow"
      />

      <div className="max-w-2xl mx-auto px-5 md:px-8 py-20 text-center">
        <div className="w-16 h-16 bg-qds-accent/10 rounded-full flex items-center justify-center mx-auto mb-6" aria-hidden="true">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-qds-accent">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </div>

        <h1 className="text-2xl md:text-3xl font-medium text-qds-text-primary mb-3">
          Ordering happens in the app
        </h1>
        <p className="text-qds-text-secondary text-sm mb-8 max-w-md mx-auto leading-relaxed">
          Browse designs here in the Inkwell, then download Quuil to customize your products,
          pick sizes and colors, and place your order.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-qds-primary text-qds-text-inverse px-7 py-3.5 rounded-xl font-medium text-base hover:bg-qds-primary-pressed transition-colors min-h-[48px]"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            Get the App to Order
          </a>
          <Link
            to="/gallery"
            className="inline-flex items-center justify-center gap-2 border border-qds-border px-7 py-3.5 rounded-xl font-medium text-base text-qds-text-primary hover:bg-qds-surface-hover transition-colors min-h-[48px]"
          >
            Browse the Inkwell
          </Link>
        </div>
      </div>
    </div>
  );
}
